import React from 'react'
import { I18n } from 'react-redux-i18n'
import { makeDetailLink } from '../table'
import { isEmpty, omitBy, debounce } from 'lodash'

export default (Component, TableFilterPanel, tableKey = '_id') =>
  (props) => (
    <TableConfig
      {...props}
      component={Component}
      tableFilterPanel={TableFilterPanel}
      tableKey={tableKey}
    />
  )

class TableConfig extends React.Component {
  state = {
    isShowFilterPanel: false,
  }

  toggleFilterPanel = () => {
    this.setState({
      ...this.state,
      isShowFilterPanel: !this.state.isShowFilterPanel,
    })
  }

  isFiltering = () =>
    !isEmpty(omitBy(this.props.filter, (value) => isEmpty(value)))

  render() {
    const {
      component: Component,
      tableFilterPanel: TableFilterPanel,
      tableKey,
      instances,
      onAdd,
      onEdit,
      btnGroup,
      hasBtnGroup = true,
      totalCount,
      currentPage,
      onPageChange,
      sizePerPage,
      onSortChange,
      onOpenDetailPopup,
      onConfirmDelete,
      ...props
    } = this.props

    const defaultOptions = {
      btnGroup: hasBtnGroup ? btnGroup : undefined,
      page: currentPage,
      sizePerPage: sizePerPage,
      sizePerPageList: sizePerPageList,
      onPageChange,
      onSortChange,
    }
    const defaultSettings = {
      data: instances,
      selectRow: { mode: 'checkbox' },
      fetchInfo: { dataTotalSize: totalCount },
      insertRow: false,
      deleteRow: false,
      tableContainerClass: 'table-kiosk',
      remote: true,
      pagination: true,
      keyField: '_id',
    }

    return (
      <Component
        {...props}
        instances={instances}
        totalCount={totalCount}
        onAdd={onAdd}
        onEdit={onEdit}
        onOpenDetailPopup={onOpenDetailPopup}
        detailLink={
          onOpenDetailPopup ? makeDetailLink(onOpenDetailPopup) : undefined
        }
        editButton={createEditButton(onEdit)}
        defaultOptions={defaultOptions}
        defaultSettings={defaultSettings}
        renderToolbar={renderToolbar(
          this.state.isShowFilterPanel,
          this.toggleFilterPanel,
          this.isFiltering(),
        )}
        isShowFilterPanel={this.state.isShowFilterPanel}
        onToggleFilterPanel={this.toggleFilterPanel}
        renderFilterPanel={renderFilterPanel(TableFilterPanel, {
          isShow: this.state.isShowFilterPanel,
          filter: this.props.filter,
          onClearFilter: this.props.onClearFilter,
          onFilterChange: this.props.onFilterChange,
        })}
      />
    )
  }
}

// const makeConfirmDeleteHandler = (tableKey, onConfirmDelete, instances) => keyList =>
//   onConfirmDelete(instances.filter(i => keyList.some(k => k === i[tableKey])))

// const createButtonGroup = onAdd => props => {
//   return (
//     <RBTButtonGroup sizeClass='btn-group-md'>
//       <InsertButton btnText={` ${I18n.t('action.add').toUpperCase()}`} onClick={onAdd} />
//       {props.deleteBtn}
//     </RBTButtonGroup>
//   );
// }

const createEditButton = (onEdit) => (cell, row) => (
  <EditButton onClick={() => onEdit(row._id)} />
)

const EditButton = ({ onClick }) => (
  <button className="btn btn-info" onClick={onClick}>
    <i className="glyphicon glyphicon-edit"></i> Edit
  </button>
)

const renderToolbar = (isShowFilterPanel, onToggleFilterPanel, isFiltering) => {
  return (
    <div className="flex justify-end mb-3">
      <button
        onClick={onToggleFilterPanel}
        className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 flex items-center gap-2 ${
          isFiltering
            ? 'bg-primary-600 text-white hover:bg-primary-700 shadow-md'
            : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400'
        }`}
      >
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
            clipRule="evenodd"
          />
        </svg>
        {I18n.t('action.filter')}
        <svg
          className={`w-4 h-4 transition-transform duration-200 ${isShowFilterPanel ? 'rotate-180' : ''}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </div>
  )
}

const renderFilterPanel = (TableFilterPanel, props) =>
  TableFilterPanel ? <TableFilterPanel {...props} /> : null

const withDataManager = (component) => (props) => (
  <TableDataManagerContainer {...props} paginatedComponent={component} />
)

const sizePerPageList = [
  { text: '5', value: 5 },
  { text: '10', value: 10 },
  { text: '50', value: 50 },
  { text: '100', value: 100 },
]

class TableDataManagerContainer extends React.Component {
  state = {
    currentPage: this.props.startPage || 1,
    sizePerPage: this.props.sizePerPage || 5,
    sort: undefined,
    order: undefined,
    filter: {},
  }

  constructor(props) {
    super(props)
    this.handleDateChange = debounce(this.handleDateChange, 350)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isRefetchItems) {
      this.handleDateChange()
      nextProps.onRefetchSuccess()
    }
  }

  handlePageChange = (currentPage, sizePerPage) => {
    this.setState(
      { ...this.state, currentPage, sizePerPage },
      this.handleDateChange,
    )
  }

  handleSortChange = (sort, order) => {
    this.setState({ ...this.state, sort, order }, this.handleDateChange)
  }

  handleFilterChange = (key, value) => {
    this.setState(
      (state) => ({
        ...state,
        filter: {
          ...state.filter,
          [key]: value,
        },
      }),
      this.handleDateChange,
    )
  }

  handleClearFilter = () => {
    this.setState(
      {
        ...this.state,
        filter: {},
      },
      this.handleDateChange,
    )
  }

  handleDateChange = () => {
    const { onDataChange } = this.props
    if (onDataChange) onDataChange(this.state)
  }

  render() {
    const { paginatedComponent: Component, ...props } = this.props

    return (
      <Component
        {...props}
        totalCount={this.props.totalCount}
        currentPage={this.state.currentPage}
        sizePerPage={this.state.sizePerPage}
        onPageChange={this.handlePageChange}
        onSortChange={this.handleSortChange}
        filter={this.state.filter}
        onClearFilter={this.handleClearFilter}
        onFilterChange={this.handleFilterChange}
      />
    )
  }
}

TableConfig = withDataManager(TableConfig)
